import { ReactNode } from 'react';

import { theme } from 'shared/styles/theme';
import { Typography } from 'shared/ui/Typography';

type Props = {
  children: ReactNode;
  marginBottom?: number;
};

export const FormCategoryTitle = ({ children, marginBottom }: Props) => (
  <Typography mb={marginBottom ?? 4} fontWeight={theme.fontWeights['bold']} fontSize='24px'>
    {children}
  </Typography>
);
